import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=9763e0fc&scoped=true"
import script from "./BaseIconButton.vue?vue&type=script&lang=js"
export * from "./BaseIconButton.vue?vue&type=script&lang=js"
import style0 from "./BaseIconButton.vue?vue&type=style&index=0&id=9763e0fc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9763e0fc",
  null
  
)

export default component.exports